import type from './Oprationalcp.type';

const initialState = {
  unarchivedCardsList: [],
  totalCards: 0,
  ocpRowColData: null,
  supplierList: [],
  cardRowsData: [],
  cardColmnsData: [],
  editData: null,
  totalDetailsRow: 0,
};

const oprationalCPReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_UNARCHIVED_CARDS:
      return {
        ...state,
        unarchivedCardsList: [...state.unarchivedCardsList, ...(action.payload?.data || [])],
        totalCards: action.payload?.totalCards,
      };
    case type.GET_ALL_ROW_COLUMDATA: {
      const previousData = state?.ocpRowColData;
      if (previousData) {
        previousData.rows = [...(previousData?.rows || []), ...(action.payload?.rows || [])];
      }
      const finalData = previousData || action.payload;
      return {
        ...state,
        ocpRowColData: finalData,
        totalDetailsRow: action.payload?.totalDetailsRow,
      };
    }
    case type.GET_ALL_SUPPLIERS:
      return {
        ...state,
        supplierList: action.payload,
      };
    case type.GET_EDIT_CARDS_DATA:
      return {
        ...state,
        editData: action.payload,
      };
    case type.GET_ALL_ROWS:
      return {
        ...state,
        cardRowsData: action.payload,
      };
    case type.GET_ALL_COLUMNS:
      return {
        ...state,
        cardColmnsData: action.payload,
      };
    case type.CLEAR_REDUCER:
      return {
        ...state,
        unarchivedCardsList: [],
        totalCards: 0,
        ocpRowColData: null,
        totalDetailsRow: 0,
        supplierList: [],
        cardRowsData: [],
        cardColmnsData: [],
        editData: null,
      };
    default:
      return state;
  }
};

export default oprationalCPReducer;
